import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Truck, ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success(`Bienvenido ${r.user.name}`);
      nav(`/${r.user.role}`);
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-white flex bg-noise">
      {/* Left: form */}
      <div className="flex-1 flex flex-col p-8 md:p-16">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-yellow-300 mb-16" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Volver
        </Link>
        <div className="max-w-md w-full my-auto">
          <div className="flex items-center gap-3 mb-12">
            <img src="/img/voycargo-logo.png" alt="VoyCargo Express" className="w-14 h-14 object-contain" />
            <div className="flex flex-col">
              <span className="font-display font-black text-xl tracking-tighter leading-none">VOYCARGO</span>
              <span className="font-mono-tech text-[10px] text-yellow-300 tracking-widest">EXPRESS</span>
            </div>
          </div>
          <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-3">/ Acceso</div>
          <h1 className="font-display font-black text-5xl tracking-tighter mb-3">Ingresar</h1>
          <p className="text-zinc-400 mb-10">Administradores, aliados y repartidores.</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="font-mono-tech text-xs uppercase tracking-widest text-zinc-400 mb-2 block">Email</label>
              <input
                data-testid="login-email"
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border border-white/20 focus:border-yellow-300 focus:ring-1 focus:ring-yellow-300/50 outline-none px-4 py-3 font-mono-tech text-sm"
                placeholder="tu@empresa.cl"
              />
            </div>
            <div>
              <label className="font-mono-tech text-xs uppercase tracking-widest text-zinc-400 mb-2 block">Contraseña</label>
              <input
                data-testid="login-password"
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border border-white/20 focus:border-yellow-300 focus:ring-1 focus:ring-yellow-300/50 outline-none px-4 py-3 font-mono-tech text-sm"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full bg-yellow-300 text-black font-bold py-4 uppercase tracking-widest hover:bg-yellow-200 disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Entrar
            </button>
          </form>
        </div>
      </div>
      {/* Right: image */}
      <div className="hidden lg:block flex-1 relative border-l border-white/10">
        <img
          src="https://images.pexels.com/photos/4391469/pexels-photo-4391469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950/90 via-zinc-950/40 to-transparent" />
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute bottom-16 left-16 right-16">
          <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-4">/ Operación 24/7</div>
          <h2 className="font-display font-black text-4xl tracking-tighter leading-tight">
&ldquo;En 3 semanas duplicamos la capacidad de despacho, sin contratar nadie.&rdquo;
          </h2>
          <div className="mt-6 text-zinc-400 text-sm">— Empresa piloto, Santiago Centro</div>
        </div>
      </div>
    </div>
  );
}
